import Handlers from '../dispatcher/Handlers';
import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, StatTypes } from '../constants/CentricConstants';

import LocationApi from '../server/LocationApi';

export default {

    getAll: (params) => {
        const types = {
            request: ActionTypes.LOCATION_LIST_REQUEST,
            success: ActionTypes.LOCATION_LIST_SUCCESS,
            failure: ActionTypes.LOCATION_LIST_FAILURE
        };
        return Dispatcher.dispatchAsync(LocationApi.getAll(params), types, {params} );
    },

    getById: (id) => {
        const types = {
            request: ActionTypes.LOCATION_INFO_REQUEST,
            success: ActionTypes.LOCATION_INFO_SUCCESS,
            failure: ActionTypes.LOCATION_INFO_FAILURE
        };
        return Dispatcher.dispatchAsync(LocationApi.getById(id), types, {id} );
    },

    save: (entity) => {
        const types = {
            request: ActionTypes.LOCATION_SAVE_REQUEST,
            success: [ActionTypes.LOCATION_SAVE_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure: ActionTypes.LOCATION_SAVE_FAILURE
        };

        return Dispatcher.dispatchAsync(LocationApi.save(entity), types, { entity });
    },

    update: (id, entity) => {
        const types = {
            request: ActionTypes.LOCATION_UPDATE_REQUEST,
            success: [ActionTypes.LOCATION_UPDATE_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure: ActionTypes.LOCATION_UPDATE_FAILURE
        };
        return Dispatcher.dispatchAsync(LocationApi.update(id, entity), types, {id, entity});
    },

    delete: (current) => {
        const types = {
            request: ActionTypes.LOCATION_DELETE_REQUEST,
            success: ActionTypes.LOCATION_DELETE_SUCCESS,
            failure: [ActionTypes.LOCATION_DELETE_FAILURE, ActionTypes.FORM_SUBMIT_ERROR]
        };
        return Dispatcher.dispatchAsync(LocationApi.delete(current.id), types, { current });
    },

    search: (search) => {
        const types = {
            success: ActionTypes.SEARCH_RESULT_RECEIVED,
            failure: ActionTypes.SEARCH_ERROR
        };
        return Dispatcher.dispatchAsync(LocationApi.search(search), types, { search });
    },

    getAllByVenue: (venueId, params) => {
        const types = {
            request: ActionTypes.LOCATION_LIST_REQUEST,
            success: ActionTypes.LOCATION_LIST_SUCCESS,
            failure: ActionTypes.LOCATION_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(LocationApi.getAllByVenue(venueId, params), types, {venueId, params} );
    },

    getContacts: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.LOCATION_CONTACT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.LOCATION_CONTACT_LIST_ERROR);
        
        return LocationApi.getContacts(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    addContact: function(id, contactId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.LOCATION_CONTACT_ADD);
        const handleError = Handlers.createErrorHandler(ActionTypes.LOCATION_CONTACT_ADD_ERROR);
        
        return LocationApi.addContact(id, contactId)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

    getEventList: (id, params) => {
        const types = {
            request:    ActionTypes.LOCATION_EVENT_LIST_REQUEST,
            success:    ActionTypes.LOCATION_EVENT_LIST_SUCCESS,
            failure:    ActionTypes.LOCATION_EVENT_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(LocationApi.getEvents(id, params), types, {id, params});
    }

};
